function isMobile() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone|Mobile|Tablet|Kindle|Silk|PlayBook|Nexus/i.test(userAgent);
    const isSmallScreen = window.matchMedia("(max-width: 1024px)").matches;
    return false;
    return isMobileDevice || isSmallScreen;
}

function nastavURL(container, url_link, projectId, language, imgSrc, floor, design) {
    if (!container) {
        console.error("Container does not exist.");
        return;
    }

    // Inicializácia obrázku
    const img = document.createElement("img");
    img.src = imgSrc;
    img.alt = "Play Molly";
    img.style.width = "100%";
    img.style.height = "auto";

    const link = document.createElement("a");

    // Použite url_link alebo predpokladajte, že je undefined
    let url = url_link || ""; 
    const params = [];

    // Kontrolujte projectId a language
    if (projectId) {
        params.push(`project=${encodeURIComponent(projectId)}`);
    }
    if (language) {
        params.push(`lang=${encodeURIComponent(language)}`);
    }
    if (floor) {
        params.push(`floor=${encodeURIComponent(floor)}`);
    }
    if (design) {
        params.push(`design=${encodeURIComponent(design)}`);
    }

    // Ak existujú parametre, pridajte ich k URL s kontrolou separátora
    if (params.length > 0) {
        const separator = url.includes('?') ? '&' : '?';
        url += `${separator}${params.join('&')}`;
    }

    link.href = url; // Nastav URL s parametrami
    link.target = "_self"; // Otvor v rovnakom okne/tabu
    
    // Pridajte obrázok do odkazu iba ak máme validnú URL
    if (url_link) {
        link.appendChild(img); // Pridaj obrázok do odkazu
        container.appendChild(link); // Pridaj odkaz do divu
    }
}


function vlozSkriptyMolly(data, projectId, container) {
    const params = new URLSearchParams();
    if (projectId) params.set('project', projectId);
    if (data.parameters.floor != null) params.set('floor', data.parameters.floor);
    if (data.parameters.design != null) params.set('design', data.parameters.design);
    if (container.dataset.zoom) params.set('zoom', container.dataset.zoom);

    const iframe = document.createElement('iframe');
    iframe.style.cssText = 'width:100%;height:100%;border:none;display:block;';
    iframe.allow = 'xr-spatial-tracking; gyroscope; accelerometer; magnetometer; fullscreen';
    iframe.allowFullscreen = true;
    iframe.src = 'https://mollyinvr.com/projects/itb/ceresne/?' + params.toString();
    container.appendChild(iframe);
}

function initWoowStudio(container) {

    const projectId = container.dataset.project ? container.dataset.project : "first";
    const language = container.dataset.language;
    const design = container.dataset.design;
    const floor = container.dataset.floor;

    let url_link = null;
    let imgSrc = "";
    let apiUrl = "https://api.mollyinvr.com/php/check-referrer.php"; 
    let apiReferrer = (window.location.protocol + "//" + window.location.hostname + "/").replaceAll("://www.", "://"); 
    console.log(apiReferrer);

    return fetch(apiUrl, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({ 
            referrer: apiReferrer,
            project: projectId 
        })
    })
    .then(response => response.ok ? response.json() : Promise.reject("Network error"))
    .then(data => {
        console.log(data);
        if (!data.url_link) {
            console.error("Not valid referrer !");
            return;
        }
        
        imgSrc = data.url_link ? `${data.url_link}embed.webp` : imgSrc;
        url_link = data.url_link || "";

        if (isMobile() && apiReferrer != "https://stockerka.sk/" ) {
            nastavURL(container, url_link, projectId, language, imgSrc, data.parameters.floor, data.parameters.design);
        } else {
            vlozSkriptyMolly(data, projectId, container);
        }
    })
    .catch(error => {
        console.error("Failed to load URL:", error);
    });
}


function closeWoowStudio(container) {
    if (!container) {
        console.error("Container does not exist.");
        return;
    }
    container.innerHTML = '';
    console.log("WoowStudio closed and cleaned up");
}

window.onload = function () {
    const containers = document.querySelectorAll(".woowstudio");
    
    if (containers.length === 1) {
        console.log("Single woowstudio container found, auto-loading...");
        initWoowStudio(containers[0]);
    } else if (containers.length === 0) {
        console.log("No woowstudio containers found. Waiting for manual initialization.");
    } else {
        console.log(`Multiple woowstudio containers found (${containers.length}).`);
    }
};

// For Alpine.js
window.initWoowStudio = initWoowStudio;
window.closeWoowStudio = closeWoowStudio;